import { IndexState } from "../index/IndexState";

const IF = require( "infrontjs" );

import './../../components/routine/routine-selection-item';
import './../../components/routine/routine-selection-individual';
import './../../components/routine/routine-dynamic';

import template from './RegistrationTemplate.html';
import { Routine } from "../../model/Routine";

export class RegistrationState extends IF.State
{
    static ROUTE = '/register';
    static ID = 'registration';

    canEnter()
    {
        return ( this.app.currentUser === null );
    }

    getRedirectUrl()
    {
        return IndexState.ROUTE;
    }

    async enter()
    {
        this.app.container.innerHTML = this.app.view.getHtml(
            template,
            {
                dailyMorningRoutines : this.app.routineManager.getRoutinesForRegistration( Routine.CATEGORY_DAILY_MORNING ),
                dailyMiddayRoutines : this.app.routineManager.getRoutinesForRegistration( Routine.CATEGORY_DAILY_MIDDAY ),
                dailyEveningRoutines : this.app.routineManager.getRoutinesForRegistration( Routine.CATEGORY_DAILY_EVENING ),
                dailyGoalRoutines : this.app.routineManager.getRoutinesForRegistration( Routine.CATEGORY_DAILY_GOAL ),
                weeklySportRoutines : this.app.routineManager.getRoutinesForRegistration( Routine.CATEGORY_WEEKLY_GOAL_SPORT ),
                weeklyConsumeRoutines : this.app.routineManager.getRoutinesForRegistration( Routine.CATEGORY_WEEKLY_GOAL_CONSUME ),
                weeklySpiritRoutines : this.app.routineManager.getRoutinesForRegistration( Routine.CATEGORY_WEEKLY_GOAL_SPIRIT )
            }
        );
        /*
        this.app.view.render(
            this.app.container,
            template,
            {
                dailyMorningRoutines : this.app.routineManager.getRoutinesForRegistration( Routine.CATEGORY_DAILY_MORNING ),
                dailyMiddayRoutines : this.app.routineManager.getRoutinesForRegistration( Routine.CATEGORY_DAILY_MIDDAY ),
                dailyEveningRoutines : this.app.routineManager.getRoutinesForRegistration( Routine.CATEGORY_DAILY_EVENING ),
                dailyGoalRoutines : this.app.routineManager.getRoutinesForRegistration( Routine.CATEGORY_DAILY_GOAL ),
                weeklySportRoutines : this.app.routineManager.getRoutinesForRegistration( Routine.CATEGORY_WEEKLY_GOAL_SPORT ),
                weeklyConsumeRoutines : this.app.routineManager.getRoutinesForRegistration( Routine.CATEGORY_WEEKLY_GOAL_CONSUME ),
                weeklySpiritRoutines : this.app.routineManager.getRoutinesForRegistration( Routine.CATEGORY_WEEKLY_GOAL_SPIRIT )
            },
            true
        );
         */

        const form = this.app.container.querySelector( 'form[data-id="registration-form"]' );

        //this.app.gui.addFormValidators( form );
        this.app.container.querySelector( '[data-id="btn-register"]' ).addEventListener(
            'click',
            async ( e ) => {

                const selectedRoutines = [],
                      checkedRoutineElements = this.app.container.querySelectorAll( 'routine-selection-item[checked], routine-selection-individual[checked], routine-dynamic[checked]' );
                let weeklyFrequence;
                checkedRoutineElements.forEach( ( r ) =>
                {
                    weeklyFrequence = 7;
                    if ( Routine.GOAL_WEEKLY === r.getAttribute( 'goal' ) && r.hasAttribute( 'weekly-frequence' ) )
                    {
                        weeklyFrequence = +r.getAttribute( 'weekly-frequence' );
                    }
                    selectedRoutines.push(
                        {
                            "id" : +r.getAttribute( 'routine-id' ),
                            "goal" : r.getAttribute( 'goal' ),
                            "categoryId" : r.getAttribute( 'category-id' ),
                            "name" : r.getAttribute( 'name' ),
                            "icon" : r.getAttribute( 'icon' ),
                            "weeklyFrequence" : weeklyFrequence
                        }
                    );
                });

                form.classList.add( 'validated' );
                if ( true === form.checkValidity() )
                {
                    const formData = IF.Helper.serializeForm( form );

                    this.app.gui.showLoader( 'Registrierung wird durchgeführt...', true );
                    let registrationResponse = null;
                    try
                    {
                        registrationResponse = await this.app.api.post(
                            '/user',
                            {
                                "name" : formData.name,
                                "email" : formData.email,
                                "password" : formData.password,
                                "data" : {
                                    selectedRoutines : selectedRoutines
                                }
                            }
                        );
                    }
                    catch ( e )
                    {
                        registrationResponse = {
                            status : 500,
                            error : e.toString()
                        };
                    }

                    if ( !registrationResponse || 201 !== registrationResponse.status )
                    {
                        let errMessage = '';
                        switch ( registrationResponse.status )
                        {
                            case 409:
                                errMessage = 'Die E-Mail existiert bereits.';
                            break;

                            default:
                                errMessage = 'Ups. Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.';
                        }
                        this.app.gui.showSnackbarError( errMessage );
                        this.app.gui.hideLoader();
                    }
                    else
                    {
                        this.app.storage.saveIsKnown( true );
                        const responseData = await registrationResponse.json();
                        this.goNextSplide();
                        this.app.gui.hideLoader();
                    }
                }
                return false;
            }
        );

        this.app.container.querySelectorAll( '[data-type="btn-splide-prev"]' ).forEach( ( elem ) => {
            elem.addEventListener(
                'click',
                ( e ) => {
                    this.goPreviousSplide();
                }
            );
        });

        this.app.container.querySelectorAll( '[data-type="btn-splide-next"]' ).forEach( ( elem ) => {
            elem.addEventListener(
                'click',
                ( e ) => {
                    this.goNextSplide();
                }
            );
        });

        this.app.container.querySelectorAll( '.card.mb-0' ).forEach( ( div ) => div.style.height = window.innerHeight + 'px' );

        setTimeout( () =>
        {
            this.registrationSplide = new Splide(
                this.app.container.querySelector( '[data-id="registration-splider"]' ),
                {
                    type : 'slide',
                    autoplay : false,
                    interval : 4000,
                    perPage: 1,
                    arrows : false,
                    pagination: false,
                    drag : false,
                    keyboard : false
                }
            ).mount();

            this.onSplideSlide();
        }, 100 );
    }

    goNextSplide()
    {
        this.registrationSplide.go( '>' );
        this.onSplideSlide();
    }

    goPreviousSplide()
    {
        this.registrationSplide.go( '<' );
        this.onSplideSlide();
    }

    onSplideSlide()
    {
        const registrationFormIndex = (this.registrationSplide.length-2);
        const successIndex = this.registrationSplide.length-1;
        switch ( this.registrationSplide.index )
        {
            case 0:
                this.app.container.querySelector( '[data-type="btn-splide-prev"]' ).disabled = true;
            break;

            case registrationFormIndex:
                this.app.container.querySelector( '[data-type="btn-splide-next"]' ).disabled = true;
                this.app.container.querySelector( '.splide-custom-pagination-bottom' ).style.pointerEvents = 'none';
            break;

            case successIndex:
                this.app.container.querySelector( '[data-type="btn-splide-next"]' ).disabled = true;
                this.app.container.querySelector( '[data-type="btn-splide-prev"]' ).disabled = true;
            break;

            default:
                this.app.container.querySelector( '[data-type="btn-splide-prev"]' ).disabled = false;
                this.app.container.querySelector( '[data-type="btn-splide-next"]' ).disabled = false;
                this.app.container.querySelector( '.splide-custom-pagination-bottom' ).style.pointerEvents = 'all';
        }
    }

    async exit()
    {
        this.registrationSplide.destroy( true );
        this.app.gui.removeFormValidators( this.app.container.querySelector( 'form[data-id="registration-form"]' ) );
    }
};
